import script from "./NestedMultiSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./NestedMultiSelect.vue?vue&type=script&setup=true&lang=js"

import "./NestedMultiSelect.vue?vue&type=style&index=0&id=478d27cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-478d27cc"]])

export default __exports__